import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'
import type { TokenPrice } from '../../interfaces/common'

export interface TokenBalance {
  id: string
  balance: number
}

interface UserTokenBalanceStore {
  balances: { [key: string]: TokenBalance[] }
  balancesForWallet: (walletId: string) => TokenBalance[]
  setBalance: (tokenId: string, walletId: string, balance: number) => void
  setBalances: (walletId: string, newBalances: TokenBalance[]) => void
  tokenPrices: TokenPrice[]
  setTokenPrices: (prices: TokenPrice[]) => void
}

export const createTokenBalancesStore = (storage: StateStorage) =>
  createStore<UserTokenBalanceStore>(
    storage,
    (set, get) => ({
      balances: {},
      tokenPrices: [],
      balancesForWallet(walletId) {
        return get().balances[walletId] || []
      },
      setBalance(tokenId, walletId, balance) {
        const balances = get().balances
        const currentBalances = balances[walletId] || []
        if (currentBalances.find((balance) => balance.id === tokenId)) {
          set({
            balances: {
              ...balances,
              [walletId]: [
                ...currentBalances.filter((balance) => balance.id !== tokenId),
                { id: tokenId, balance },
              ],
            },
          })
        } else {
          set({
            balances: {
              ...balances,
              [walletId]: [...currentBalances, { id: tokenId, balance }],
            },
          })
        }
      },
      setBalances(walletId, newBalances) {
        const balances = get().balances
        const oldBalances = (balances[walletId] || []).filter(
          (b) => !newBalances.map((nb) => nb.id).includes(b.id)
        )

        set({
          balances: {
            ...balances,
            [walletId]: [...oldBalances, ...newBalances],
          },
        })
      },
      setTokenPrices(prices) {
        set({ tokenPrices: prices })
      },
    }),
    {
      persist: {
        name: 'userTokenBalances',
        version: 0,
      },
    }
  )
